import { createAction } from '@reduxjs/toolkit';

export const eventsUpdateId = createAction('events/updateId');
export const eventsUpdateUID = createAction('events/updateUid');
export const eventsUpdateSID = createAction('events/updateSid');
export const eventsUpdateIsAdded = createAction('events/updateIsAdded');
export const eventsUpdateIsActive = createAction('events/updateIsActive');

export const eventsStore = createAction('events/store');
export const eventsClear = createAction('events/clear');

export const eventsUpdateRequest = createAction('events/updateRequest');
export const eventsUpdateError = createAction('events/updateError');
export const eventsUpdateStore = createAction('events/updateStore');

export const eventsUpdateHeadingTitle = createAction('events/updateHeadingTitle');
export const eventsUpdateHeadingDescription = createAction('events/updateHeadingDescription');
export const eventsUpdateHeadingTextAlign = createAction('events/updateHeadingTextAlign');
export const eventsUpdateHeadingImage = createAction('events/updateHeadingImage');
export const eventsUpdateHeadingDivider = createAction('events/updateHeadingDivider');

export const eventsUpdateSectionIsBackground = createAction('events/updateSectionIsBackground');
export const eventsUpdateSectionTextColor = createAction('events/updateSectionTextColor');
export const eventsUpdateSectionBackgroundColor = createAction('events/updateSectionBackgroundColor');
export const eventsUpdateSectionOpacity = createAction('events/updateSectionOpacity');
export const eventsUpdateSectionIsFullWidth = createAction('events/updateSectionIsFullWidth');
export const eventsUpdateSectionShadow = createAction('events/updateSectionShadow');
export const eventsUpdateSectionShadowColor = createAction('events/updateSectionShadowColor');
export const eventsUpdateSectionPadding = createAction('events/updateSectionPadding');
export const eventsUpdateSectionMargin = createAction('events/updateSectionMargin');
export const eventsUpdateSectionBackgroundType = createAction('events/updateSectionBackgroundType');
export const eventsUpdateSectionBackgroundImage = createAction('events/updateSectionBackgroundImage');
export const eventsUpdateSectionGradientColor1 = createAction('events/updateSectionGradientColor1');
export const eventsUpdateSectionGradientColor2 = createAction('events/updateSectionGradientColor2');
export const eventsUpdateSectionGradientDirection = createAction('events/updateSectionGradientDirection');
export const eventsUpdateSectionGradientOffset = createAction('events/updateSectionGradientOffset');
export const eventsUpdateSectionBorder = createAction('events/updateSectionBorder');
export const eventsUpdateSectionBorderColor = createAction('events/updateSectionBorderColor');
export const eventsUpdateSectionShadowBorderColor = createAction('events/updateSectionShadowBorderColor');
export const eventsUpdateSectionShape = createAction('events/updateSectionShape');

export const eventsUpdateItemShadow = createAction('events/updateItemShadow');
export const eventsUpdateItemShadowColor = createAction('events/updateItemShadowColor');
export const eventsUpdateItemBorder = createAction('events/updateItemBorder');
export const eventsUpdateItemBorderColor = createAction('events/updateItemBorderColor');
export const eventsUpdateItemShape = createAction('events/updateItemShape');
export const eventsUpdateItemTextColor = createAction('events/updateItemTextColor');
export const eventsUpdateItemBackgroundColor = createAction('events/updateItemBackgroundColor');

export const eventsUpdateView = createAction('events/updateView');
export const eventsUpdateItems = createAction('events/updateItems');
